import { Component, OnInit, OnDestroy } from '@angular/core';
import { SigSocketService } from '../../../../../base/services/websockets/sigsocket.service';
import { Router } from '@angular/router';
import { WebSocketSubject } from 'rxjs/webSocket';
import { Subscription } from 'rxjs';

@Component({
  selector: 'redirect-mfs',
  templateUrl: './redirect-mfs.component.html',
  styleUrls: ['./redirect-mfs.component.scss'],
})
export class RedirectMfsComponent implements OnInit, OnDestroy {
  login: string = 'assets/images/logo-ivnosys-loading.png';

  websocket: WebSocketSubject<any>;
  queryParams: string = '';
  private subscription: Subscription = new Subscription();

  constructor(private _sigSocketService: SigSocketService, private _router: Router) {}

  ngOnInit(): void {
    this.queryParams = this._router.url.split('?id=')[1];

    this.websocket = this._sigSocketService.activateWebSocket(this.queryParams, 2);

    this.subscription.add(
      this._sigSocketService.getConnectionStatus().subscribe((isConnected) => {
        if (!isConnected) {
        }
      })
    );

    this.subscription.add(
      this._sigSocketService.webSocketSuccess.subscribe((success) => {
        if (success) {
          window.close();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();

    if (this._sigSocketService.isConnected()) {
      this._sigSocketService.closeWebSocket();
    }
  }
}
